module.exports = __webpack_public_path__ + "img/image.4a17058c.png";